module.exports = {
	"app": {
		"captchaKey": "6LfIbSUTAAAAAFJa5oS_oxhvUhuVwx2q7y4_2vsW"
	},
	"googleAnalytics": {
		"tracker": "UA-9331047-21",
		"pumb_tracker": "UA-9331047-1",
		"displayFeatures": true,
		"crossDomainLinker": false,
		"fields": {},
		"setDomainName": "payhub.com.ua",
		"setPageEvent": "$stateChangeSuccess",
		"trackEvent": true,
		"trackEcommerce": true,
		"useECommerce": true,
		"setCurrency": "UAH",
		"enterDebugMode": false,
		"logAllCalls": false
	},
	"comunn": [
		{
			"serviceId": 14145,
			"name": "First select"
		},
		{
			"serviceId": 14713,
			"name": "Second select"
		}
	],
	"credits_pay": {
		"serviceId": 98203,
		"fields": {
			"account": "account",
			"inn": "inn"
		},
		"payments": {
			"min": 1,
			"max": 15000
		}
	},
	"internet": [
		{
			"serviceId": 11855,
			"fields": {
				"account": "clientId"
			},
			"payments": {
				"min": 2,
				"max": 5000
			}
		},
		{
			"serviceId": 12322,
			"fields": {
				"account": "clientId"
			},
			"payments": {
				"min": 2,
				"max": 5000
			}
		},
		{
			"serviceId": 12327,
			"fields": {
				"account": "clientId"
			},
			"payments": {
				"min": 1,
				"max": 5000
			}
		},
		{
			"serviceId": 12767,
			"fields": {
				"account": "clientId"
			},
			"payments": {
				"min": 2,
				"max": 5000
			}
		}
	],
	"mobile_codes": [
		{
			"name": "Life",
			"codes": [
				"63",
				"93",
				"73"
			]
		},
		{
			"name": "Kievstar",
			"codes": [
				"67",
				"97",
				"68",
				"96",
				"98"
			]
		},
		{
			"name": "MTC",
			"codes": [
				"50",
				"95",
				"66",
				"99",
				"75"
			]
		},
		{
			"name": "Golden Telecom",
			"codes": [
				"39"
			]
		},
		{
			"name": "Utel",
			"codes": [
				"91"
			]
		},
		{
			"name": "Intertelecom",
			"codes": [
				"94"
			]
		},
		{
			"name": "PeopleNet",
			"codes": [
				"92"
			]
		},
		{
			"name": "3Mob",
			"codes": [
				"91"
			]
		}
	],
	"mobile_phone_pay": [
		{
			"serviceId": 41313,
			"fields": {
				"phone": "MOBILE_PHONE"
			},
			"icon": "",
			"payments": {
				"min": 2,
				"max": 5000
			}
		}
	],
	"payments_config": {
		"secure3d": {
			"hiddenMethod": true
		},
		"service": {
			"pay2you": 13788,
			"metallist": 13743,
			"nonContractExternal": 13062,
			"CreditFUIB": 98203
		},
		"MFO": {
			"PUMB": 334851,
			"BRK": 380010
		},
		"energyCalc": {
			"kievEnergo": 12219,
			"kievEnergoElectricity": 12885,
			"dtekDneproblenergo": 12883,
			"tariffs": [
				[
					{
						"from": 0,
						"to": 100,
						"tariff": 0.9
					},
					{
						"from": 100,
						"to": "Infinity",
						"tariff": 1.68
					},
					{
						"large_family": 0.9
					}
				],
				[
					{
						"from": 0,
						"to": 3000,
						"tariff": 0.9
					},
					{
						"from": 3000,
						"to": "Infinity",
						"tariff": 1.68
					},
					{
						"large_family": 0.9
					}
				],
				1.68,
				0.9
			]
		}
	},
	"re_captcha": {
		"captchaKey": "6LfIbSUTAAAAAFJa5oS_oxhvUhuVwx2q7y4_2vsW"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./app/data/configs.json
 ** module id = 546
 ** module chunks = 1
 **/